import { db, type SchemaTableRow } from './schema';
export type AttendanceOpPackageListRow = {
  operationPackageId: string;
  inProgressCount: number;
};
export type AttendanceOpPackagePatternRow = {
  operationPackagePatternId: string;
  nameKey: string;
};
export type AttendanceOpPackageInstancesPage = {
  items: SchemaTableRow[];
  count: number;
  maxPage: number;
};
export async function listAttendanceOpPackages(): Promise<AttendanceOpPackageListRow[]> {
  const rows = await db.attendanceOpPackages.toArray();
  rows.sort((a, b) => a.groupIndex - b.groupIndex || a.sortOrder - b.sortOrder || a.id.localeCompare(b.id));
  return rows.map(r => ({
    operationPackageId: r.id,
    inProgressCount: r.inProgressCount
  }));
}
export async function listAttendanceOpPackagePatterns(packageId: string): Promise<AttendanceOpPackagePatternRow[]> {
  const rows = await db.attendanceOpPackagePatterns.where('packageId').equals(packageId).sortBy('sortOrder');
  return rows.map(r => ({
    operationPackagePatternId: r.id,
    nameKey: r.nameKey
  }));
}
export async function listAttendanceOpPackageInstancesByPattern(patternId: string, options?: {
  page?: number;
  pageSize?: number;
  targetId?: string;
}): Promise<AttendanceOpPackageInstancesPage> {
  const page = options?.page ?? 1;
  const pageSize = options?.pageSize ?? 50;
  const targetId = options?.targetId;
  let rows = await db.attendanceOpPackageInstanceItems.where('patternId').equals(patternId).sortBy('sortOrder');
  if (targetId) {
    rows = rows.filter(r => r.row.target.targetId === targetId);
  }
  const count = rows.length;
  const maxPage = Math.max(1, Math.ceil(count / pageSize));
  const start = (page - 1) * pageSize;
  const items = rows.slice(start, start + pageSize).map(r => r.row);
  return {
    items,
    count,
    maxPage
  };
}
export async function getAttendanceOpPackagePatternTaskCount(_operationPackageId: string, patternId: string): Promise<{
  operationPackagePatternId: string;
  count: number;
}> {
  const n = await db.attendanceOpPackageInstanceItems.where('patternId').equals(patternId).count();
  return {
    operationPackagePatternId: patternId,
    count: n
  };
}